import { defineComponent, h } from 'vue';

/** One label | gutter | value row; gutter drag from inject (nearest PropertyGrid2 ancestor). */
export default defineComponent({
    name: 'pg2-grid-row',
    inject: {
        pg2SplitPointerDown: {
            from: 'pg2SplitPointerDown',
            default: null,
        },
    },
    computed: {
        pg2ShowSplitter() {
            return typeof this.pg2SplitPointerDown === 'function';
        },
    },
    render() {
        const onDown = (e) => this.pg2SplitPointerDown?.(e, e.currentTarget);
        const label = <div class="c-PropertyGrid2__label">{this.$slots.label?.()}</div>;
        const value = (
            <div class={{ 'c-PropertyGrid2__value': true, 'property-grid': true }}>{this.$slots.default?.()}</div>
        );

        if (this.pg2ShowSplitter) {
            return (
                <div class="c-PropertyGrid2__row">
                    {label}
                    <div class="c-PropertyGrid2__gutter" aria-hidden="true" onPointerdown={onDown} />
                    {value}
                </div>
            );
        }

        return (
            <div class="c-PropertyGrid2__row c-PropertyGrid2__row--noSplit">
                {label}
                {value}
            </div>
        );
    },
});
